'use client';

import type { ICropStatus } from '@repo/sdk';
import { Badge } from '@repo/ui';
import type { JSX } from 'react';

const STATUS_STYLES: Record<ICropStatus, string> = {
  pending: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  cropping: 'bg-blue-100 text-blue-800 border-blue-300 animate-pulse',
  cropped: 'bg-green-100 text-green-800 border-green-300',
  uploading: 'bg-purple-100 text-purple-800 border-purple-300 animate-pulse',
  uploaded: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  failed: 'bg-red-100 text-red-800 border-red-300',
};

interface ICropStatusBadgeProps {
  status: ICropStatus;
}

export function CropStatusBadge({ status }: ICropStatusBadgeProps): JSX.Element {
  return (
    <Badge variant="outline" className={STATUS_STYLES[status]}>
      {status}
    </Badge>
  );
}
